import React, { forwardRef } from 'react';
import cn from 'classnames';
import Tooltip from '../../../common/components/Tooltip';
import SvgIcon from '../../../common/SvgIcon';
import BriefRooms from '../../brief/components/BriefRooms';

// const QUANTITY = Array.from(Array(11).keys());
const tooltip = `By booking any additional rooms in now you can benefit
  from having the same designer create a cohesive look throughout your home.
  You'll also save money with our multi room offer: receive £40 off each additional
  room from 3 or more, when booking a Complete Design Experience package.`;
const stopPropagation = e => {
  e.preventDefault();
  e.stopPropagation();
};

// const GettingStartedRoom = ({ room, value, proPlatform = false, onChange }) => {
//   const { quantity, selected } = useMemo(
//     () => {
//       const selectedRoom = value.find(v => v.type === room.value);
//       const roomQuantity = (selectedRoom && selectedRoom.quantity) || 0;
//       return {
//         quantity: roomQuantity,
//         selected: roomQuantity > 0,
//       };
//     },
//     [value, room],
//   );
//   return (
//     <Fragment>
//       <input
//         key={`input_${room.value}`}
//         readOnly
//         className="block-selection_input image-selection_input"
//         type="radio"
//         value={room.value}
//         id={`room_type_${room.value}`}
//         checked={selected}
//       />
//       <label
//         key={`label_${room.value}`}
//         htmlFor={`room_type_${room.value}`}
//         className={cn('block-selection_item-inner -quantity -mint', {
//           '-half-width': room.halfWidth,
//         })}
//         onClick={() => {
//           onChange({ type: room.value, quantity: selected ? 0 : 1 });
//         }}
//       >
//         {room.icon.map(icon => (
//           <svg className="block-selection_image">
//             <use xlinkHref={`#icon_room-${icon}`} xmlnsXlink="http://www.w3.org/1999/xlink" />
//           </svg>
//         )
//         )}
//         <div className="block-selection_text">
//           <span>{room.label}</span>
//           <span className="hint">{room.hint}</span>
//         </div>
//         {selected && (
//           <div className="block-selection_quantity" onClick={stopPropagation}>
//             <div className="quantity label">Quantity</div>
//             <div className="quantity-control">
//               <select
//                 className="block-selection_select"
//                 value={quantity}
//                 onChange={e => {
//                   stopPropagation(e);
//                   onChange({ type: room.value, quantity: +e.target.value });
//                 }}
//               >
//                 {QUANTITY.map(q => (
//                   <option key={`quantity-${q}`} value={q}>
//                     {q}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         )}
//         {room.tooltip &&
//           !proPlatform && (
//             <Tooltip
//               className="block-selection_tooltip"
//               tooltip={room.tooltip}
//               data-tooltip-left={1}
//             >
//               i
//             </Tooltip>
//           )}
//       </label>
//     </Fragment>
//   );
// };

const GettingStartedRooms = (
  { value, options, invalid, className, onChange, proPlatform, children },
  ref,
) => (
  <div ref={ref} className={cn('tab', className)}>
    <div className="tab_question">{`Question 2 of ${proPlatform ? '5' : '7'}`}</div>
    <div className="tab_tag">
      <SvgIcon icon="icon-question-step-3" />
    </div>
    <div className="tab_title">
      <div className={cn('-bold', { 'has-error -error-position-right': invalid })}>
        Select the room(s) you wish to design
        {invalid && <div className="form-error">please, select your room(s)</div>}
      </div>
      {!proPlatform && (
        <div className="tile-selection_bottom-description">
          Looking to design multiple rooms? A discount is available when you buy 3 or more rooms at
          the same time.{' '}
          <Tooltip tooltip={tooltip} data-tooltip-left={1}>
            <a href="#" onClick={stopPropagation}>
              View details
            </a>
          </Tooltip>
          .
        </div>
      )}
    </div>
    <div className="brief_rooms-grid">
      <BriefRooms value={value} proPlatform={proPlatform} options={options} onChange={onChange} />
    </div>
    {children}
  </div>
);

export default forwardRef(GettingStartedRooms);



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedRooms.js